// bandeiras com prioridade para SVG
import visa from "../../../../assets/bandeiras/visa.svg";
import mastercard from "../../../../assets/bandeiras/mastercard.svg";
// import hipercard from "../../../../assets/bandeiras/hipercard.svg";
import elo from "../../../../assets/bandeiras/elo.svg";
// import maestro from "../../../../assets/bandeiras/maestro.svg";

import jcb from "../../../../assets/bandeiras/jcb.svg";
import cabal from "../../../../assets/bandeiras/cabal.svg";
import credz from "../../../../assets/bandeiras/credz.svg";
import discover from "../../../../assets/bandeiras/discover.svg";
import sorocred from "../../../../assets/bandeiras/sorocred.svg";
import diners from "../../../../assets/bandeiras/diners.svg";

const FlagsCard = () => {
	return (
		<div className="flex flex-wrap gap-2 h-6 sm:h-4 xs:h-4  ">
			<img src={visa} className="h-4 sm:h-4 xs:h-4" alt="Visa" />
			<img src={mastercard} className="h-4 sm:h-4 xs:h-4" alt="Mastercard" />
			{/* <img src={hipercard} className="h-4 sm:h-4 xs:h-4" alt="Hipercard" /> */}
			<img src={elo} className="h-4 sm:h-4 xs:h-4" alt="Elo" />
			{/* <img src={maestro} className="h-4 sm:h-4 xs:h-4" alt="Maestro" /> */}

			{/* novas bandeiras */}
			<img src={jcb} className="h-4 sm:h-4 xs:h-4" alt="JCB" />
			<img src={cabal} className="h-4 sm:h-4 xs:h-4" alt="Cabal" />
			<img src={credz} className="h-4 sm:h-4 xs:h-4" alt="Credz" />
			<img src={discover} className="h-4 sm:h-4 xs:h-4" alt="Discover" />
			<img src={sorocred} className="h-4 sm:h-4 xs:h-4" alt="Sorocred" />
			<img src={diners} className="h-4 sm:h-4 xs:h-4" alt="Diners Club" />
		</div>
	);
};

export default FlagsCard;

// import elo from "../../../../../../assets/bandeiras/elo.svg";
// import hipercard from "../../../../assets/bandeiras/hipercard.jpg";
// import maestro from "../../../../assets/bandeiras/maestro.jpg";
// import mastercard from "../../../../assets/bandeiras/mastercard.svg";
// import visa from "../../../../assets/bandeiras/visa.jpg";

// const FlagsCard = () => {
// 	return (
// 		<div className="flex flex-wrap gap-2 h-6 sm:h-4 xs:h-4 justify-end">
// 			<img src={visa} className="h-4 sm:h-4 xs:h-4" alt="Visa" />
// 			<img src={mastercard} className="h-4 sm:h-4 xs:h-4" alt="Mastercard" />
// 			<img src={hipercard} className="h-4 sm:h-4 xs:h-4" alt="Hipercard" />
// 			<img src={elo} className="h-4 sm:h-4 xs:h-4" alt="Elo" />
// 			<img src={maestro} className="h-4 sm:h-4 xs:h-4" alt="Maestro" />
// 		</div>
// 	);
// };

// export default FlagsCard;
